import { createReducer } from '@reduxjs/toolkit';
import { clearCampaignsForTimeline, getCampaignsForTimeline, updateCampaignsTimeline } from './actions';
import { CampaignsTimelineState } from './types';

const initialState: CampaignsTimelineState = {
  loading: true,
  campaigns: [],
};

export default createReducer(initialState, builder => {
  builder
    .addCase(getCampaignsForTimeline.pending, state => {
      state.loading = true;
    })
    .addCase(getCampaignsForTimeline.fulfilled, (state, action) => {
      state.campaigns = action.payload.filter(({ LAUNCH_DATE, END_DATE }) => !!LAUNCH_DATE && !!END_DATE);
      state.loading = false;
    })
    .addCase(getCampaignsForTimeline.rejected, state => {
      state.loading = false;
    })
    .addCase(updateCampaignsTimeline.pending, state => {
      state.loading = true;
    })
    .addCase(updateCampaignsTimeline.rejected, state => {
      state.loading = false;
    })
    .addCase(clearCampaignsForTimeline, state => {
      state.campaigns = initialState.campaigns;
      state.loading = initialState.loading;
    })
});
